let useExpandedDateFormat = window.deliveryInformation.useExpandedFormat || false;

let standardDeliveryDates = document.querySelectorAll(
    ".js-standard-delivery-date"
  );
  if (standardDeliveryDates.length) {
    getStandardDeliveryDate();
    cutoffCountdown();
  }
  
  document.addEventListener("get-delivery-date", () => {
    getStandardDeliveryDate();
  });
  
  let dispatchDates = document.querySelectorAll(".js-dispatch-date");
  
  if (dispatchDates.length) {
    getDispatchDate();
  }
  
  document.addEventListener("get-dispatch-date", () => {
    getDispatchDate();
  });

  //Delivery date functionalty not currently being used due to dates not being guaranteed. This function gives the delivery date for standard delivery option, options are in theme settings. Function below can be used if O'briens want to use in future
  function getStandardDeliveryDate() {
    if (window.deliveryInformation && window.deliveryInformation.cutOff) {
      const now = new Date();
      const day = now.getDay(); // 0 (Sun) to 6 (Sat)
  
      // Cutoff time
      const [cutoffHour, cutoffMinute] = window.deliveryInformation.cutOff.split(":");
      const cutoffTime = new Date(now);
      cutoffTime.setHours(cutoffHour, cutoffMinute, 0, 0);
  
      let dispatchDate = new Date(now);
  
      // Determine when the order will be dispatched
      if (day >= 5) {
        // Friday (5), Saturday (6), Sunday (0) — dispatch on Monday
        const daysUntilMonday = (8 - day) % 7;
        dispatchDate.setDate(dispatchDate.getDate() + daysUntilMonday);
      } else if (now < cutoffTime) {
        // Mon–Thu before cutoff — dispatch today
        // No change to dispatchDate
      } else {
        // Mon–Thu after cutoff — dispatch tomorrow
        dispatchDate.setDate(dispatchDate.getDate() + 1);
  
        // If tomorrow is Fri–Sun, push to Monday
        const nextDay = dispatchDate.getDay();
        if (nextDay === 5) {
          dispatchDate.setDate(dispatchDate.getDate() + 3); // Friday → Monday
        } else if (nextDay === 6) {
          dispatchDate.setDate(dispatchDate.getDate() + 2); // Saturday → Monday
        } else if (nextDay === 0) {
          dispatchDate.setDate(dispatchDate.getDate() + 1); // Sunday → Monday
        }
      }
  
      // Add 1 **delivery day** from dispatch date
      const deliveryDate = new Date(dispatchDate);
      let deliveryDayCount = 0;
      while (deliveryDayCount < 1) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
        const dateStr = ("0" + deliveryDate.getDate()).slice(-2) + "/" + ("0" + (deliveryDate.getMonth() + 1)).slice(-2);
        const isExcluded = window.deliveryInformation.excludedDates.split(",").includes(dateStr);
        const dayKey = ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"][deliveryDate.getDay()];
        const isDeliveryDay = window.deliveryInformation.deliveryDates[dayKey];
  
        if (isDeliveryDay && !isExcluded) {
          deliveryDayCount++;
        }
      }
  
      // Format and display delivery date
      const formattedDate = addDaysToDate(0, deliveryDate); // updated function below
      document.querySelectorAll(".js-standard-delivery-date").forEach((dateElem) => {
        dateElem.innerHTML = formattedDate;
      });
    }
  }
  
  function isBeforeCutOfftime () {
    let nowTime = new Date();
    let cutOffTime = new Date(
      new Date().setHours(
        window.deliveryInformation.cutOff
      )
    );
    return nowTime < cutOffTime;
  }
  
  function getDispatchDate() {
    if (window.deliveryInformation.cutOff) {
      let nowTime = new Date();
      let cutOffTime = new Date(
        new Date().setHours(
          window.deliveryInformation.cutOff.split(":")[0],
          window.deliveryInformation.cutOff.split(":")[1]
        )
      );
      let daysToAdd = 0;
 
  
      let dateString = addDaysToDate(daysToAdd);
  
      //populate delivery dates
      dispatchDates = document.querySelectorAll(".js-dispatch-date");
      dispatchDates.forEach((dateElem) => {
        dateElem.innerHTML = dateString;
      });
    }
  }
  
  function addDaysToDate(daysToAdd = 0, startDate = null) {
    //loop through days until the daystoadd has been reached with included shipping days
    //e.g. if a day isn't included in shipping days, it will be skipped until X amount of days have been counted
    let excludedDates = window.deliveryInformation.excludedDates.split(",");
    let deliveryDate = startDate ? new Date(startDate) : new Date();
  
    let days = ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"];
    let fullDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  
    let months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    let fullMonths = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
  
    let countedDays = 0;
    let loopCount = 0;
    while (countedDays <= daysToAdd) {
      let thisDate = new Date(deliveryDate);
      thisDate.setDate(deliveryDate.getDate() + loopCount);
  
      let thisDateString =
        ("0" + thisDate.getDate()).slice(-2) +
        "/" +
        ("0" + (thisDate.getMonth() + 1)).slice(-2);
  
      let isExcluded = excludedDates.includes(thisDateString);
      let isDeliveryDay = window.deliveryInformation.deliveryDates[
        days[thisDate.getDay()]
      ];
  
      if (isDeliveryDay && !isExcluded) {
        deliveryDate = thisDate;
        countedDays++;
      }
  
      loopCount++;
    }
  
    let deliveryDayName = useExpandedDateFormat
      ? fullDays[deliveryDate.getDay()]
      : days[deliveryDate.getDay()];
    let deliveryDay = deliveryDate.getDate();
    let deliveryMonth = useExpandedDateFormat
      ? fullMonths[deliveryDate.getMonth()]
      : months[deliveryDate.getMonth()];
  
    let deliveryDateString = useExpandedDateFormat
      ? `${deliveryDayName}, ${deliveryMonth} ${deliveryDay}`
      : `${deliveryDayName} ${deliveryDay} ${deliveryMonth}`;
  
    let deliveryString;
    if (isBeforeCutOfftime()) {
      deliveryString = window.deliveryInformation.dateString
        .replace("(cutoff)", window.deliveryInformation.cutOff)
        .replace("(date)", deliveryDateString)
        .replace("(hours)", "<span data-time='hours'></span>")
        .replace("(minutes)", "<span data-time='minutes'></span>")
        .replace("(seconds)", "<span data-time='seconds'></span>");
    } else {
      deliveryString = window.deliveryInformation.cutoffString.replace(
        "(date)",
        deliveryDateString
      );
    }
  
    return deliveryString;
  }
  

  function cutoffCountdown () {

    var today = new Date();
    var timeFormatted = window.deliveryInformation.cutOff.replace('.', ':');
    var inputDate = (today.getMonth()+1) + '/' + today.getDate() + '/' + today.getFullYear() + ' ' + timeFormatted;
    var countDownDate = new Date(inputDate).getTime();

    var x = setInterval(function() {

      // Get today's date and time
      var now = new Date().getTime();

      var distance = countDownDate - now;

      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
      // Output the result in an element with id="demo"
      document.querySelectorAll('[data-time="hours"]').forEach((hour) => { hour.innerHTML = hours });
      document.querySelectorAll('[data-time="minutes"]').forEach((minute) => { minute.innerHTML = minutes });
      document.querySelectorAll('[data-time="seconds"]').forEach((second) => { second.innerHTML = seconds });
        
      // If the count down is over, write some text 
      if (distance <= 1000) {
        clearInterval(x);
      }
    }, 1000);
  }
  
